import { FC, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';

interface MatchParams {
    restaurantSlug: string;
    eventSlug: string;
}

export const EventRedirect: FC<RouteComponentProps<MatchParams>> = ({
    match,
}) => {
    useEffect(() => {
        const { restaurantSlug, eventSlug } = match.params;
        window.location.href = `https://www.dineout.is/${restaurantSlug}/event/${eventSlug}`;
    }, []);

    return <div>Redirecting you to our new event booking experience.</div>;
};
